
<div :class="jel_getClassObject(content)">
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider
    v-slot="validationContext"
    :name="content.libCodePostal"
    :rules="`required|compteValidation:codePostal`"
    mode="aggressive"
    tag="div"
  >
    <b-form-group :label="content.libCodePostal" label-for="codePostal">
      <b-form-input
        :id="content.idHTML ? content.idHTML : 'codePostal'"
        v-model="codePostal"
        :maxlength="$t('compte.codePostal.mask').length"
        autocomplete="postal-code"
        :state="getValidationState(validationContext)"
        :disabled="disabled"
        @keydown.enter="getValidationState(validationContext)"
        @keyup.native="maskCodePostal($event)"
      ></b-form-input>
      <ErreurValidation
        id="codePostal-live-feedback"
        :message="validationContext.errors[0]"
      ></ErreurValidation>
    </b-form-group>
  </ValidationProvider>
</div>
